/**
 * Convert a comma separated string to an array of strings
 * @param csv The comma separated string
 */
export function csvToArray(csv?: string): string[] | undefined {
  if (!csv) {
    return undefined;
  }
  return csv.split(",").map((item) => item.trim());
}
